import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  FormControlComponent,
  PrimengButtonDirective,
  PrimengPasswordDirective,
} from '@web/shared/ui';
import { Button } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { generateRandomPassword } from '@web/utils';
import { ResetPasswordForm } from '../../models/reset-password-form';

type ResetPasswordFormGroup = FormGroup<{
  password: FormControl<string>;
}>;

@Component({
  selector: 'app-reset-password-form',
  imports: [
    ReactiveFormsModule,
    FormControlComponent,
    Button,
    PrimengButtonDirective,
    PrimengPasswordDirective,
    PasswordModule,
  ],
  templateUrl: './reset-password-form.component.html',
  styleUrl: './reset-password-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordFormComponent {
  private readonly builder = inject(FormBuilder);

  public readonly submitClickEvent = output<ResetPasswordForm>();
  public readonly form = this.buildForm();

  public handleSubmitClick(): void {
    this.submitClickEvent.emit(this.toData());
  }

  public handleGeneratePasswordClick(): void {
    this.form.controls.password.patchValue(generateRandomPassword());
  }

  private toData(): ResetPasswordForm {
    const data = this.form.getRawValue();

    return new ResetPasswordForm(data.password);
  }

  private buildForm(): ResetPasswordFormGroup {
    return this.builder.group({
      password: this.builder.nonNullable.control('', [Validators.required]),
    });
  }
}
